import { graphql, fetchQuery, Environment } from 'react-relay';
import { Dispatch, Store } from 'redux';
import { getUserZipCode } from 'dibs-regional-info/exports/regionalInfoHelpers';

import { SHOW_SHOP_LOCAL_TOAST } from './shopLocalConstants';
import { hasRecentlyDismissedShopLocalPrompt } from './shopLocalHelpers';

import {
    shopLocalConfigQuery,
    shopLocalConfigQueryResponse,
} from './__generated__/shopLocalConfigQuery.graphql';

const shouldShowShopLocal = async ({
    relayEnvironment,
    store,
}: {
    relayEnvironment: Environment;
    store: Store;
}): Promise<boolean> => {
    // dispatch action not to overlap shopLocal and footer marketing banners
    const hideMarketingBanner = (value: boolean): void => {
        store.dispatch({
            type: SHOW_SHOP_LOCAL_TOAST,
            showShopLocalToast: value,
        });
    };

    if (hasRecentlyDismissedShopLocalPrompt()) {
        hideMarketingBanner(false);
        return Promise.resolve(false);
    }
    const zipCode = getUserZipCode();
    if (!zipCode || zipCode === '0') {
        hideMarketingBanner(false);
        return Promise.resolve(false);
    }

    const response: shopLocalConfigQueryResponse = await fetchQuery<shopLocalConfigQuery>(
        relayEnvironment,
        graphql`
            query shopLocalConfigQuery {
                viewer {
                    shopLocalNotificationFeatureFlag: featureFlag(feature: "shopLocalNotification")
                }
            }
        `,
        {}
    );

    const showShopLocal = Boolean(response.viewer.shopLocalNotificationFeatureFlag);

    hideMarketingBanner(showShopLocal);

    return showShopLocal;
};

export const shopLocalConfig = {
    name: 'shopLocal',
    rule: shouldShowShopLocal,
    action: (): unknown => (dispatch: Dispatch) => {
        dispatch({
            type: SHOW_SHOP_LOCAL_TOAST,
            showShopLocalToast: true,
        });
    },
    priority: 50,
};
